import { FunctionComponent, ReactNode, PropsWithChildren } from 'react';

import { Modal, Backdrop, Fade, Card, CardActions, CardContent, Divider } from '@mui/material';

interface AnnouncementModalProps {
  cardActions: ReactNode;
  cardContent: ReactNode;
  open: boolean;
  onBackdropClick?: () => void;
}

export const AnnouncementModal: FunctionComponent<PropsWithChildren<AnnouncementModalProps>> = ({
  cardActions,
  cardContent,
  open,
  onBackdropClick,
}) => {
  const handleClose = (event: unknown, reason?: string) => {
    if (reason === 'backdropClick' && onBackdropClick) {
      onBackdropClick();
    }
  };

  return (
    <Modal
      aria-labelledby="announcement-modal"
      aria-describedby="announcement-modal"
      open={open}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
      onClose={handleClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .MuiPaper-root': {
          outline: 'none',
        },
      }}
    >
      <Fade in={open}>
        <Card square sx={{ minWidth: '60vw' }}>
          <CardContent>{cardContent}</CardContent>
          <Divider />
          <CardActions
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '1rem',
            }}
          >
            {cardActions}
          </CardActions>
        </Card>
      </Fade>
    </Modal>
  );
};
